// Import Core
import React, { useState, useEffect } from "react";
// Import Components
import CardCarouselProduct from "../CardCarouselProduct";
// Import Utils
import getNavItemLinks from "../../../utils/getNavItemLinks";
import { getSpecialOffers } from "../../../utils/getSpecialOffers";
import { graphql, useStaticQuery } from "gatsby";

const SpecialOffersCardCarousel = ({ section }) => {
  // const data = useStaticQuery(graphql`
  //   query SepcialOfferQuery {
  //     specialOffers: allSanitySpecialOffer {
  //       nodes {
  //         _id
  //         _type
  //         title
  //         excerpt
  //         enabled
  //         # thumbnail {
  //         #   asset {
  //         #     gatsbyImageData(height: 280, placeholder: BLURRED)
  //         #   }
  //         # }
  //         assignedCptType
  //         assignedCptTailorMadeHoliday {
  //           ...SanityTailorMadeHolidayFragment
  //         }
  //         assignedCptRailJourney {
  //           ...SanityRailJourneyFragment
  //         }
  //         assignedCptOpera {
  //           ...SanityOperaFragment
  //         }
  //         assignedCptHotelBreak {
  //           ...SanityHotelBreakFragment
  //         }
  //         assignedCptCulturalTour {
  //           ...SanityCulturalTourFragment
  //         }
  //         assignedCptAttraction {
  //           ...SanityAttractionFragment
  //         }
  //       }
  //     }
  //   }
  // `);

  // const specialOffers = data.specialOffers.nodes;

  // const [results, setResults] = useState(null);

  // useEffect(() => {
  //   // Loop through special offers and for each type make a new object
  //   if (
  //     section.selectedSpecialOffers &&
  //     section.selectedSpecialOffers.length > 0
  //   ) {
  //     const updatedSpecialOffers = getSpecialOffers(specialOffers).slice(0, 20);
  //     setResults(updatedSpecialOffers);
  //   }
  // }, [data]);

  // console.log("result", specialOffers[0]);
  // console.log("section", section.selectedSpecialOffers[0]);

  const updatedSpecialOffers = getSpecialOffers(section.selectedSpecialOffers);

  return (
    <CardCarouselProduct
      productType="specialOffer"
      addToAnchor={section.addToAnchor}
      title={section.sectionTitle.title}
      content={section.sectionTitle.caption}
      linkText={section.navItem && section.navItem.name}
      link={
        section.navItem &&
        section.navItem.navItemUrl &&
        getNavItemLinks(section.navItem)
      }
      cardList={updatedSpecialOffers}
    />
  );
};

export default SpecialOffersCardCarousel;
